import { render, staticRenderFns } from "./LegendPlugin.vue?vue&type=template&id=dbd2c68a&scoped=true"
import script from "./LegendPlugin.vue?vue&type=script&lang=ts"
export * from "./LegendPlugin.vue?vue&type=script&lang=ts"
import style0 from "./LegendPlugin.vue?vue&type=style&index=0&id=dbd2c68a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd2c68a",
  null
  
)

export default component.exports